import i18n from "i18next";

import type { PrimaryFunction } from "api/services/content/schemas/shared";

export function translatePrimaryFunction(primaryFunction: PrimaryFunction): string {
  const keyMap: Record<PrimaryFunction, string> = {
    balance: i18n.t("library.exercises.fields.primary_function_options.balance"),
    mobility: i18n.t("library.exercises.fields.primary_function_options.mobility"),
    strength: i18n.t("library.exercises.fields.primary_function_options.strength"),
  };

  return keyMap[primaryFunction] || "";
}
